import Badge from "react-bootstrap/Badge";
import { Link } from "react-router-dom";

function teaser(description) {
  if (Array.isArray(description)) {
    const first = description.find((s) => typeof s === "string" && s.trim());
    if (!first) return "";
    return first.replace(/^•\s*/, "");
  }
  return typeof description === "string" ? description : "";
}

export default function CatalogItemCard({ item, horizontal = false }) {
  const imageUrl = item.imageUrl ?? item.image;
  const placeholderLabel = item.imageAlt ?? item.name;
  const desc = teaser(item.description);
  const hasPack = item.packQty != null && item.packQty !== "" && item.packUnit;
  const materials = Array.isArray(item.materials) ? item.materials : [];

  return (
    <Link
      to={`/catalog/${encodeURIComponent(item.sku)}`}
      className="pmp-product-card-link d-block text-decoration-none h-100"
    >
      <div
        className={`pmp-product-card${horizontal ? " pmp-product-card--horizontal" : ""}`}
      >
        {/* Fixed 1:1 box; product photos (varying size/crop/bg) are centered and
            contained on white so nothing is cropped and every tile lines up. */}
        <div className="pmp-product-card-media">
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={item.imageAlt ?? item.name}
              className="pmp-product-card-img"
            />
          ) : (
            <div className="pmp-product-card-placeholder">{placeholderLabel}</div>
          )}
        </div>
        <div className="pmp-product-card-body">
          <h3 className="pmp-product-card-title">{item.name}</h3>
          {desc && <p className="pmp-product-card-desc">{desc}</p>}
          {!horizontal && item.sizes ? (
            <p
              className="font-monospace text-body-secondary mb-0"
              style={{ fontSize: "0.7rem", letterSpacing: "0.01em" }}
            >
              <span
                className="text-uppercase text-body-secondary fw-semibold"
                style={{ fontSize: "0.6rem", letterSpacing: "0.08em" }}
              >
                Sizes
              </span>{" "}
              {item.sizes}
            </p>
          ) : null}
          {horizontal ? (
            <>
              <dl
                className="row mb-0 small mt-2"
                style={{ borderTop: "1px solid rgba(0,0,0,0.08)", paddingTop: "1rem" }}
              >
                <dt className="col-sm-4 col-lg-3 text-secondary fw-normal">SKU</dt>
                <dd className="col-sm-8 col-lg-9 font-monospace mb-3">{item.sku}</dd>
                {hasPack ? (
                  <>
                    <dt className="col-sm-4 col-lg-3 text-secondary fw-normal">Pack</dt>
                    <dd className="col-sm-8 col-lg-9 mb-3">
                      {item.packQty} per {item.packUnit}
                    </dd>
                  </>
                ) : null}
                {item.sizes ? (
                  <>
                    <dt className="col-sm-4 col-lg-3 text-secondary fw-normal">Sizes</dt>
                    <dd className="col-sm-8 col-lg-9 mb-3">{item.sizes}</dd>
                  </>
                ) : null}
              </dl>
              {materials.length ? (
                <div className="mt-1 mb-3">
                  <p className="small text-secondary mb-2 fw-semibold">Materials</p>
                  <div className="d-flex flex-wrap gap-2">
                    {materials.map((m, i) => (
                      <Badge
                        key={`${i}-${m}`}
                        pill
                        bg="primary"
                        className="fw-normal px-3 py-2"
                      >
                        {m}
                      </Badge>
                    ))}
                  </div>
                </div>
              ) : null}
            </>
          ) : null}
          <div className="d-flex align-items-center justify-content-between mt-auto pt-1">
            {!horizontal ? (
              <span className="d-inline-flex align-items-baseline gap-1">
                <span
                  className="text-uppercase text-body-secondary fw-semibold"
                  style={{ fontSize: "0.6rem", letterSpacing: "0.08em" }}
                >
                  SKU
                </span>
                <span className="small font-monospace fw-semibold text-body">{item.sku}</span>
              </span>
            ) : null}
            <span className="pmp-product-card-arrow">View details &#x2192;</span>
          </div>
        </div>
      </div>
    </Link>
  );
}
